import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import { useCallback } from "react";
import React from "react";



const ParticleSystem =  React.memo(() => {
 

 const options = {
  fullScreen: {
    enable: false,
    zIndex: -1
  },
  fpsLimit: 60,
  interactivity: {
    events: {
      onClick: { enable: true, mode: "repulse" },
      onHover: { enable: true, mode: "bubble" },
      resize: true
    },
    modes: {
      push: { quantity: 1 },
      bubble: {
        distance: 150,
        duration: 2,
        size: 8,
        opacity: 0.8
      },
    }
  },
  particles: {
    number: {
      value: 10,
      density: {
        enable: true,
        area: 40
      }
    },
    color: { value: ["#3865cf", "#ff0000","#ffff"] }, // multiple colors
    shape: {
      type: ["circle", "square"], // multiple shapes
    },
    links: {
      enable: true,
      distance: 150,
      color: "#ffff",
      opacity: 0.5,
      width: 1
    },
    collisions: { enable: false },
    move: {
      enable: true,
      speed: 2,
      direction: "none",
      random: false,
      straight: false,
      outModes: { default: "bounce" }
    },
    opacity: {
      value: 0.5,
      random: false
    },
    size: {
      value: 3,
      random: true,
      animation: {
        enable: true,
        speed: 3,
        size_min: 1,
        sync: false
      }
    }
  },
  detectRetina: true
};




  const particlesInit = useCallback(async (engine) => {
  

    // you can initialize the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadSlim(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
   
  }, []);

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={options}
      autoDestroy={false}
      autoPlay="true"
      style={{ position: "absolute", top: 0, left: 0 }}
    />
  );
});

export default ParticleSystem;
